import WorkspacePremiumTwoToneIcon from '@mui/icons-material/WorkspacePremiumTwoTone';

function TabelaOceanoAzul({ dados, cargo, tipoGrafico }) {
    const renderTabelaGeral = () => {
        const rank = (arr) => {
            const tmpArr = arr.map(v => ({
                value: v,
                rank: 1,
            }));

            const unique = new Set(arr);

            for (let a of unique) {
                for (let b of tmpArr) {

                    if (b.value < a) {
                        b.rank += 1;
                    }
                }
            }

            return tmpArr.map(v => v.rank);
        };

        const classificacaoPeloNivelA = rank(dados.map(item => parseInt(item.nivel_a)));

        const dadosRankeados = dados.map(({ agrupador, nivel_a, nivel_b, nivel_c, nivel_d, nivel_e, ...rest }, index) => ({
            agrupador: agrupador,
            nivel_a: nivel_a,
            nivel_b: nivel_b,
            nivel_c: nivel_c,
            nivel_d: nivel_d,
            nivel_e: nivel_e,
            posicao: classificacaoPeloNivelA[index]
        }));

        return (
            <table className="table-progresso">
                <thead>
                    <tr className="bg-gray-200 text-center">
                        <th className="border border-gray-300 px-4 py-2">Mês</th>
                        <th className="border border-gray-300 px-4 py-2">Nível A</th>
                        <th className="border border-gray-300 px-4 py-2">Nível B</th>
                        <th className="border border-gray-300 px-4 py-2">Nível C</th>
                        <th className="border border-gray-300 px-4 py-2">Nível D</th>
                        <th className="border border-gray-300 px-4 py-2">Nível E</th>
                    </tr>
                </thead>
                <tbody>
                    {dadosRankeados.map((item, index) => (
                        <tr key={index} className="text-center">
                            <td className="w-56 h-12">
                                <div className="flex items-center justify-between">
                                    <p>{item.agrupador}</p>
                                    {(item.posicao === 1 && item.nivel_a > 0) && <WorkspacePremiumTwoToneIcon className="text-yellow-500 ml-2" />}
                                    {(item.posicao === 2 && item.nivel_a > 0) && <WorkspacePremiumTwoToneIcon className="text-gray-500 ml-2" />}
                                    {(item.posicao === 3 && item.nivel_a > 0) && <WorkspacePremiumTwoToneIcon className="text-yellow-700 ml-2" />}
                                </div>
                            </td>
                            <td className="border border-gray-300 px-4 py-2">{item.nivel_a}</td>
                            <td className="border border-gray-300 px-4 py-2">{item.nivel_b}</td>
                            <td className="border border-gray-300 px-4 py-2">{item.nivel_c}</td>
                            <td className="border border-gray-300 px-4 py-2">{item.nivel_d}</td>
                            <td className="border border-gray-300 px-4 py-2">{item.nivel_e}</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr className="text-center">
                        <td className="border border-gray-300 px-4 py-2">Anual</td>
                        <td className="border border-gray-300 px-4 py-2">{dados[0].somanivel_a}</td>
                        <td className="border border-gray-300 px-4 py-2">{dados[0].somanivel_b}</td>
                        <td className="border border-gray-300 px-4 py-2">{dados[0].somanivel_c}</td>
                        <td className="border border-gray-300 px-4 py-2">{dados[0].somanivel_d}</td>
                        <td className="border border-gray-300 px-4 py-2">{dados[0].somanivel_e}</td>
                    </tr>
                </tfoot>
            </table>
        );
    };

    const renderTabelaIndividual = () => {
        return (
            <table className="table-progresso">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="coluna-departamento">Mês</th>
                        <th className="text-center">Nível</th>
                        <th className="text-center">Pontuação</th>
                    </tr>
                </thead>
                <tbody>
                    {dados.map((item, index) => (
                        <tr key={index}>
                             <td className="w-56 h-12">
                                <div className="flex items-center justify-between">
                                    <p>{item.agrupador}</p>
                                    {item.nivel === 'A' && <WorkspacePremiumTwoToneIcon className="text-yellow-500 ml-2" />}
                                </div>
                            </td>
                            <td className="w-56 h-12">{item.nivel}</td>
                            <td className="w-56 h-12">{item.pontuacao}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    const tituloTabela = () => {
        if (cargo === 'VENDEDOR') {
            return 'Acompanhe uma visão detalhada do seu desempenho';
        }

        if (cargo === 'GERENTE_LOJA') {
            return tipoGrafico == 1 ? 'Acompanhe uma visão detalhada do seu desempenho' : 'Acompanhe uma visão detalhada do desempenho dos seus funcionários';
        }

        if (cargo === 'GERENTE_REGIONAL') {
            return tipoGrafico == 3 ? 'Acompanhe uma visão detalhada do seu desempenho' : 'Acompanhe uma visão detalhada do desempenho dos seus funcionários'
        }

        return 'Acompanhe uma visão detalhada do desempenho dos seus funcionários';
        
    };

    function gerarTabela() {
        if (cargo === 'VENDEDOR') {
            return renderTabelaIndividual();
        }

        if (cargo === 'GERENTE_LOJA') {
            return tipoGrafico == 1 ? renderTabelaIndividual() : renderTabelaGeral();
        }

        if (cargo === 'GERENTE_REGIONAL') {
            return tipoGrafico == 3 ? renderTabelaIndividual() : renderTabelaGeral();
        }

        return renderTabelaGeral();
        
    }

    return (
        <section className="py-12 bg-gradient-to-b from-gray-c22 to-white">
            <div className="container">
                <div className="font-poppins text-gray-c5 text-center">
                    <h2 className="font-semibold text-[26px]">{tituloTabela()}</h2>
                    <div className="overflow-x-auto my-6">
                        <div className="table-wrapper bg-white">
                            {gerarTabela()}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TabelaOceanoAzul